export const PARTNER_CONNECTION_TYPE = "partners";
export const FRIEND_CONNECTION_TYPE = "friends";

export const API_ENDPOINTS = {
  // base API urls
  REGISTER: `/register`,
  confirmEmail: (id, token) => `/confirm-email/${id}/${token}`,
  RESEND_REGISTER: `/resend/register`,
  UPDATE_FCM_TOKEN: `user/fcm-token`,
  LOGIN: `/login`,
  VERIFY_2FA: `/verify-2fa`,
  RESEND_LOGIN: `/resend/login`,
  TOKEN_REFRESH: `/token-refresh`,
  PASSWORD_RESET: `/password-reset`,
  passwordResetConfirm: (encoded_pk, token) =>
    `/password-reset-confirm/${encoded_pk}/${token}`,
  LOGOUT: `/logout`,
  LOGOUT_ALL: `/logout-all`,
  PRODUCTS: `/products`,
  STATIONS: `/stations`,
  // user API urls # reminder: Use API_USER_URL below
  USER_ME: `/user/me`,
  // CHANGE_NAME: `/user/change-name`,
  CHANGE_NAME: `/user/change-user-details`,
  CHANGE_EMAIL: `/user/change-email`,
  CHANGE_PASSWORD: `/user/change-password`,
  CHANGE_PROFILE_PICTURE: `/user/change-profile-picture`,
  DASHBOARD: `/user/dashboard`,
  TRANSACTIONS: `/user/transactions`,
  transactionById: (id) => `/user/transactions/${id}`,
  TRANSACTION_TYPES: `/transaction-types`,
  VEHICLES: `/user/vehicles`,
  vehicleById: (id) => `/user/vehicles/${id}`,
  FIND_BY_EMAIL: `/user/find-by-email`,
  CONNECTIONS: `/user/connections`,
  FRIEND_REQUESTS: `/user/friend-requests`,
  SEND_FRIEND_REQUEST: `/user/friend-requests/send`,
  ACCEPT_FRIEND_REQUEST: `/user/friend-requests/accept`,
  REJECT_FRIEND_REQUEST: `/user/friend-requests/reject`,
  CANCEL_FRIEND_REQUEST: `/user/friend-requests/cancel`,
  REMOVE_FRIEND: `/user/remove-friend`,
  BALANCES: `/user/product-balances`,
  REGISTER_ORDER: `/payment/register`,
  syncOrder: (order_number) => `/payment/sync/${order_number}`,
};

export const PAYMENT_STATES = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  PROCESSING: "PROCESSING",
};
